var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"socket",class:['socket--' + _vm.socket.name.toLowerCase(), 'socket--' + _vm.type]})
}
var staticRenderFns = []

export { render, staticRenderFns }